module.exports = __webpack_public_path__ + "img/点赞03_u2863.21652f53.svg";